const devBio = {
    description: `Hey, I’m Karan 👋. I’m a full-stack developer who loves blending logic with creativity to bring ideas to life. I enjoy building websites and web apps that aren’t just functional, but also fun and engaging to use.

    I get excited about smooth effects, intuitive interfaces, and anything that makes a user go “oh wow, that’s cool.”
    
    Here are a few technologies I've been working with recently:`,
    tools: [
        'Flutter (Dart)',
        'React',
        'Node.js',
        'Vue',
        'Python',
        'Django',
        'Java',
        'C#',
        'MongoDB',
        'Firebase',
        'GSAP'],
    image: '/assets/images/about/devAvatar.png',
    webpImage: '/assets/images/about/devAvatar.webp',
    caption: 'Bridging logic and creativity with clean, scalable code.'
}

export default devBio;